import * as types from './actionTypes';
import { defaultStore } from './store';
import { IUserStore } from './types';

export default (
  state = defaultStore,
  action: types.IUserActions
): IUserStore => {
  switch (action.type) {
    case types.SET_USER:
      return { ...state, ...action.user };
    case types.SET_LOGIN_ERROR:
      return { ...state, loginError: action.msg };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/services/user/reducers.tsx